import CrossTabChart from "../../../../src/components/pulse/CrossTabChart";
import * as React from 'react';
export default {
  CrossTabChart,
  React
};